module.exports = __webpack_public_path__ + "img/icon4.e27e308d.png";